module.exports = __webpack_public_path__ + "img/slidebar-bg.8e91c4bb.png";